import { type Icon, P, SvgIcon } from "@sveabank/cc-common";

type Props = {
	text: string;
	imageSrc: Icon;
	height?: number;
};

const IconWithText = ({ text, imageSrc, height = 21 }: Props) => (
	<div className="flex flex-row items-center gap-4 py-4">
		<SvgIcon imageSrc={imageSrc} height={height} />
		<P>{text}</P>
	</div>
);

export default IconWithText;
